// Modelo de lista de textos de los posibles proveedores
export default class RewardListTextProvider {
    constructor (
         public name : string = "",
         public text : string = "",  
    ) {

    }
}
